<template>
    <div class="dashboard-component" id="success">
        <div v-bind:class="bannerclass">
            <container>
                <header v-if ="normaldevice">
                    <div class="inner">
                        <grid horizontal="left">
                            <grid-item size="2/12" class="logo-opacity">
                                <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg"></a>
                            </grid-item>

                            <grid-item size="10/12" class="nav-items">
                                <ul class="top-menu">
                                    <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                    <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                    <li><a href="#" @click="openNewTab()">SIGNIN</a></li>
                                </ul>
                            </grid-item>


                        </grid>
                    </div>
                </header>
                <header v-if ="smalldevice">
                    <div class="inner-sm">
                        <grid horizontal="left">
                            <grid-item size="2/12" class="logo-opacity">
                                <a href="/"><img class="v-middle" src="../assets/images/logo_white.svg"></a>
                                <!-- <span class="logo-text">vLite</span> -->
                            </grid-item>

                            <grid-item size="10/12" class="nav-items">
                                <button type="button" class="btn-hamb" @click="toggleSidebar">
                                    <span class="strike"></span>
                                    <span class="strike"></span>
                                    <span class="strike"></span>
                                </button>
                                <button v-bind:class="susbtncolor" type="button"  @click="navigateToHomeWithDiv('plans')">SUBSCRIBE</button>
                            </grid-item>


                        </grid>

                        <div class="sidebar" v-show="sidebarVisible">
                            <div class="menus">
                                <ul>
                                    <li><a href="#" @click="navigateToHomeWithDiv('howitwork')">HOW IT WORKS</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('features')">FEATURES</a></li>
                                    <li><a href="#" @click="navigateToHomeWithDiv('plans')">PLANS</a></li>
                                    <li><a href="#" v-scroll-to="'#plans'">BLOG</a></li>
                                    <li><a href="#" @click="openNewTab()">SIGNIN</a></li>

                                </ul>
                            </div>
                            <button type="button" class="btn-close-sidebar" @click="toggleSidebar">
                                <icon scale="2.5" style="color:#bcbcbc;" name="times"></icon>
                            </button>
                        </div>
                    </div>
                </header>
                <div class="banner-content">
                    <h1 class="white-text">{{title}}</h1>
                    <h2 class="white-text">{{titlemsg}}</h2>
                    <grid horizontal="left" class="vl-rltv">
                        <grid-item size="8/12" class="zindex101">
                            <h4 class="banner-text-normal white-text">Our support team shall contact you shortly!</h4>
                            <!-- <h4 class="banner-text-normal white-text">{{message}} <strong>{{email}}</strong></h4> -->
                            <button v-bind:class="buttonclass" type="button" @click="requestagain()">REQUEST AGAIN</button>
                        </grid-item>
                        <grid-item  size="4/12" class="v-middle right zindex101 vl-bnr-top-ico">
                            <div class="top-right-gfx">
                            </div>
                        </grid-item>
                    </grid>

                </div>
            </container>
        </div>

        <div class="success-basic">
            <container>
                <p class="center success-p p-top-30">Thanks for your Live Demo Request for MOOC/Entertainment. Our support team shall contact you to setup a convenient slot shortly. You should have received a mail regarding the same. </p>
                <!-- <p class="center success-p">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas fermentum id quam et sollicitudin. Nunc eu nisi dignissim, laoreet mauris a, maximus mi. Vivamus porttitor bibendum orci, ac interdum.</p> -->
                <div class="clearfix"></div>
            </container>
        </div>

        <div class="success-back-color success-back-pad">
            <container >
                <p class="center success-help m-0">Need Help?</p>
                <p class="center success-p m-0">Please contact us at <strong>vlitesupport@mobiotics.com</strong> for any help.</p>
                <div class="clearfix"></div>
            </container>
        </div>

        <!--Footer-->
        <footer class="page-footer">
            <div class="footer-color">
                <container>
                    <grid>
                        <grid-item size="4/12">
                            <div class="vl-foot-left">
                                <div class=" logo-opacity">
                                    <!-- <img class="v-middle" src="../assets/images/v-lite-white-logo.svg"><span class="logo-text">vLite</span> -->
                                    <img class="v-middle" src="../assets/images/logo_white.svg" style="width:20%;">
                                </div>
                            <p class="foot-copy">&copy; Copyright <label id="copyrightyear"></label><a href="https://www.mobiotics.com" target="_blank">
                                <img class="v-middle foot-cmp-logo" src="../assets/images/mobiotics-logo-horizontal.svg"></a></p>

                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-mid">
                                <ul>
                                    <li><a @click="openSocialNewTab('https://www.facebook.com/mobiotics')"><icon scale="1.2" class="white-text" name="facebook"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://plus.google.com/106588943035549674608/posts')"><icon scale="1.5" class="white-text" name="google-plus"></icon></a></li>
                                    <li><a @click="openSocialNewTab('https://twitter.com/mobiotics')"><icon scale="1.2" class="white-text" name="twitter"></icon></a></li>
                                </ul>
                            </div>
                        </grid-item>
                        <grid-item size="4/12">
                            <div class="vl-foot-right f-right">
                            <p class="foot-copy"><a href="#">Terms Of Use</a></p>
                            <p class="foot-copy"><a href="#">Privacy Policy</a></p>
                            </div>
                            <!-- <div class="vl-foot-right">
                                <ul>
                                    <li><a href="#">Terms of use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                </ul>
                            </div> -->
                        </grid-item>
                    </grid>
                </container>
            </div>
        </footer>
        <!-- basic -->

    </div>



</template>

<script>
    const { Config } = require('../assets/js/config.js');

    export default{
        data(){
            return{
                email: 'quizzertv@gmail.com',
                bannerclass: ['banner','failed-banner'],
                buttonclass: ['btn','banner-get-btn-success','raise'],
                title:'',
                titlemsg:'',
                message:'',
                status:'',
                reason:'Something Went Wrong, Try Again',
                demoData:{},
                apibaseurl:'',
                vendorportalurl:'',
                normaldevice: true,
                smalldevice: false,
                sidebarVisible: false,
                susbtncolor: ['banner-head-blue-btn','btn-head','banner-head-get-btn','raise'],
            };
        },
        created () {
            this.screenResize();
             this.email = this.$route.params.email;
             this.status = this.$route.params.status;
             this.reason = this.$route.params.reason;
             this.demoData = this.$route.params.demoData;

             if((this.status) =='success'){
                 this.title = 'Thanks !';
                 this.titlemsg = 'Your request for live demo has been received';
                 this.message = "A Live video demo has been sent to"
                this.buttonclass= ['btn', 'banner-get-btn-success','raise'];
                this.bannerclass= ['banner','success-banner'];
                this.susbtncolor = ['banner-head-blue-btn','btn-head','banner-head-get-btn','raise'];
            }else if((this.status) =='failed'){
                this.title = 'Failed !';
                this.titlemsg = 'Your request Can\'t be Processed';
                this.message = "Because of "+this.reason;
                this.buttonclass= ['btn', 'banner-get-btn-failed','raise'];
                this.bannerclass= ['banner','failed-banner'];
                this.susbtncolor = ['banner-head-rd-btn','btn-head','banner-head-get-btn','raise'];
            }else{
                this.title = 'Failed !';
                this.titlemsg = 'Your request Can\'t be Processed';
                this.message='Something Went Wrong, Try Again';
                this.buttonclass= ['btn', 'banner-get-btn-failed','raise'];
                this.bannerclass= ['banner','failed-banner'];
                this.susbtncolor = ['banner-head-rd-btn','btn-head','banner-head-get-btn','raise'];
            }
        },
        mounted() {
                // Setting Config URLs
                var con = new Config()
                this.apibaseurl = con.getApiUrl();
                this.vendorportalurl = con.getPortalUrl();
                this.$scrollTo('#success');

                var thisYear  = new Date().getFullYear();
                console.log(document.getElementById('copyrightyear'));
                document.getElementById('copyrightyear').innerHTML = thisYear;
        },
        watch: {
            '$mq.resize': 'screenResize'
        },
        methods: {
            openSocialNewTab(surl){
                window.open(surl, '_blank');
            },
            openNewTab() {
                window.open(this.vendorportalurl, '_blank');
            },
            navigateToHomeWithDiv(divname){
                this.$router.push({ name: 'Home', params: { divid: divname}});
            },
            requestagain(){
                this.$router.push({ name: 'Reqdemo', params: { resetData:this.demoData }});
            },
            screenResize() {
                var scsize = screen.width;
                if (scsize >= 601) {
                    this.normaldevice= true;
                    this.smalldevice= false;

                }else if (scsize <= 600) {
                    this.normaldevice= false;
                    this.smalldevice= true;

                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Democonfirm.vue